module.exports = __webpack_public_path__ + "img/image-currency.0f583e2b.jpg";